import { Direction, GameState, Position } from '../interfaces/game.interface';

// ============================================
// Client to Server - Game Input DTOs
// ============================================

/**
 * Standardized player input for movement
 * Used for all directional input from clients
 */
export interface PlayerInputDto {
  gameId: string;
  playerId: string;
  direction: Direction;
  sequence: number; // Sequence number for input reconciliation in client prediction
  clientTimestamp?: number; // Optional: for latency measurement
}

// ============================================
// Client to Server - Game Event DTOs (Legacy classes)
// ============================================

export class JoinGameDto {
  constructor(public gameId: string, public playerId: string) {}
}

export class LeaveGameDto {
  constructor(public gameId: string, public playerId: string) {}
}

export class MoveSnakeDto {
  constructor(
    public gameId: string,
    public playerId: string,
    public direction: Direction
  ) {}
}

export class UseAttackDto {
  constructor(
    public gameId: string,
    public playerId: string,
    public targetPlayerId?: string
  ) {}
}

export class UsePowerUpDto {
  constructor(
    public gameId: string,
    public playerId: string,
    public targetPlayerId?: string
  ) {}
}

export class SwitchPowerUpDto {
  constructor(public gameId: string, public playerId: string) {}
}

// ============================================
// Server to Client - Game State DTOs
// ============================================

export class GameStateDto {
  constructor(public gameState: GameState) {}
}

/**
 * Server tick update with timestamp and tick number
 * Used for synchronized game state updates
 */
export interface ServerTickDto {
  gameState: GameState;
  timestamp: number;
  tickNumber: number;
}

/**
 * Countdown event before game starts
 * Sent periodically during the countdown phase
 */
export interface CountdownEventDto {
  gameId: string;
  countdown: number; // seconds remaining
  startTime: number; // timestamp when game will start
}

/**
 * Block attack notification with warning period
 * Sent when player places obstacles on the board
 */
export interface BlockAttackDto {
  gameId: string;
  playerId: string;
  targetPositions: Position[];
  warningDuration: number; // milliseconds before blocks become solid
}

// ============================================
// Server to Client - Game Event DTOs (Legacy classes)
// ============================================

export class GameStartDto {
  constructor(
    public gameId: string,
    public startTime: number,
    public countdown: number
  ) {}
}

export class GameOverDto {
  constructor(
    public gameId: string,
    public winnerId: string,
    public playerScores: Record<string, number>
  ) {}
}

export class AttackIncomingDto {
  constructor(
    public gameId: string,
    public playerId: string,
    public targetPositions: Array<{ x: number; y: number }>
  ) {}
}
